import React from "react";
import { ComponentProps } from "api-sdk-react";
import { ReaderConfig } from "reader-common";
import { ChatStyleConfig } from "../../types";

export interface ChatMessageHeaderProps extends ComponentProps {
    config: ReaderConfig,
    styleConfig: ChatStyleConfig,
    target: "user" | "partner"
}

export function ChatMessageHeader(props: ChatMessageHeaderProps) {

    const name = props.styleConfig[props.target == "user" ? "userName" : "partnerName"]
    const icon = props.styleConfig[props.target == "user" ? "userIconUrl" : "partnerIconUrl"]

    if (name || icon)
    {
        const content = [
            name ? <span key="name">{ name.toUpperCase() }</span> : null,
            icon ? <img key="icon" src={icon} /> : null
        ].filter(c => c != null)

        if (props.target === "partner") {
            content.reverse()
        }

        return (
            <div className="message-header" key="message-header">
                { content }
            </div>
        )
    }
    return null

}